import { createContext, useContext } from "react";

export const DeskFlashContext = createContext([null, () => {}]);
export const useDeskFlash = () => useContext(DeskFlashContext);
